import { authoriseOpenBankingRefund } from "@api";
import { SupportEmail } from "@components";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ProcessingIcon, SuccessIcon, FailIcon } from "@components";

const AuthoriseRefundCallback = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const consent = searchParams.get("consent");
  const error = searchParams.get("error");
  const [status, setStatus] = useState("Processing");

  useEffect(() => {
    async function processSuccess() {
      try {
        await authoriseOpenBankingRefund(id, consent);
        setStatus("Authorised");
      // TODO: handle failure better here
      }
      catch {
        console.error("Authorisation API request failed:", err);
        setStatus("AuthorisationError");
      }
    }

    async function processError() {
      //if (paymentId) {
      //  await failOpenBankingPayment(paymentId, error);
      //}
      // TODO:Set refund failed

      setStatus("Error");
    }

    if (error) {
      processError();
    }

    if (id && consent && !error) {
      processSuccess();
    }
  }, [id, consent, error]);

  return (<div className="w-full flex flex-col py-16 items-center">
    {status === "Processing" && <>
      <ProcessingIcon />
      <p className="font-semibold w-72 text-center mt-8">Authorisation complete, initiating payment...</p>
    </>}
    {status === "Authorised" && <>
      <SuccessIcon />
      <p className="font-semibold w-72 text-center mt-8">Payment authorised.<br />Please return to the Ontik dashboard.<br />You can close this tab</p>
    </>}
    {status === "AuthorisationError" && <>
      <FailIcon />
      <p className="font-semibold w-72 text-center mt-8">Your authorisation was successful but we were unable to create the payment.</p>
      <p className="text-muted fs-8 w-100 mt-auto text-center mb-2">
        If the issue persists, please contact us at <SupportEmail />.
      </p>
    </>}
    {status === "Error" && <>
      <FailIcon />
      <p className="font-semibold w-72 text-center mt-8">Your payment was not authorised, this is an issue with your banking provider. If the issue persists please contact them directly</p>
      <p className="text-muted fs-8 w-100 mt-auto text-center mb-2">
        If the issue persists please contact them directly.
      </p>
    </>}

  </div>
  );
};

export default AuthoriseRefundCallback;
